export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyDA1VaWhADwRbaET-yYmlyR8fFV9igLvAQ",
    authDomain: "atom-ebb83.firebaseapp.com",
    projectId: "atom-ebb83",
    storageBucket: "atom-ebb83.appspot.com",
    messagingSenderId: "144912422997",
    appId: "1:144912422997:web:c936b781009eba664d5cdc",
    measurementId: "G-CC28QDKR1Y",
    vapidKey: "BKaA_ScwKS0tEbfHs_PBA2AcxmrORbx4OilsNKDr4OZB06QWGNL8snTOEXp6hMuPEdYqD07uDNglDu0bp5PIrhM"
  },
  defaultauth: 'fackbackend',
  captcha: "6LfQpE8UAAAAAFzsUhEJv7ef373o-Gat0F2P5Qhe",
  ssoLogIn: 'https://ssouat.neoffice.app/auth/realms/{clientCode}/protocol/openid-connect/auth?client_id={clientCode}&redirect_uri=https://uat.neoffice.app/risksecure/?client={clientCode}&response_type=code&response_mode=fragment',
  ssoLogOut: 'https://ssouat.neoffice.app/auth/realms/{clientCode}/protocol/openid-connect/logout?client_id={clientCode}&redirect_uri=https%3A%2F%2F{clientCode}.neoffice.app',

  baseUrl: "https://ticketuat.neoffice.app/ticket/",
  // baseUrl: 'http://localhost:8027/ticket/',
  // baseTemplateDownloadUrl: "http://localhost:4200/assets/excel/"
  baseTemplateDownloadUrl: "https://ticketuat.neoffice.app/assets/excel/"
};
